import { Badge, Button, Spinner, Table } from "react-bootstrap";

const STATUS_BADGE = {
  Aberto: "secondary",
  Recebido: "success",
  Parcial: "warning",
  Atrasado: "danger",
};

function formatCurrency(value) {
  const amount = Number(value) || 0;
  return amount.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

function formatDate(value) {
  if (!value) return "—";
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    const [year, month, day] = value.slice(0, 10).split("-");
    return `${day}/${month}/${year}`;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("pt-BR");
}

function getStatusBadge(status) {
  const label = status || "Aberto";
  return { label, bg: STATUS_BADGE[label] || "secondary" };
}

export default function PaymentsTable({
  isFetching,
  payments,
  onEdit,
  onDelete,
  isDeleting,
}) {
  if (isFetching) {
    return (
      <div className="d-flex justify-content-center m-5">
        <Spinner animation="border" variant="warning" />
      </div>
    );
  }

  if (!payments?.length) {
    return (
      <p className="text-muted mb-0">Nenhuma cobrança cadastrada.</p>
    );
  }

  return (
    <div className="table-responsive">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Cliente</th>
            <th>Processo</th>
            <th>Vencimento</th>
            <th>Valor</th>
            <th>Status</th>
            <th style={{ width: 120 }}>Ações</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((payment) => {
            const status = getStatusBadge(payment.status);
            return (
              <tr key={payment.id}>
                <td>{payment.client || "—"}</td>
                <td>{payment.lawsuit_number || "—"}</td>
                <td>{formatDate(payment.due_date)}</td>
                <td>{formatCurrency(payment.value)}</td>
                <td>
                  <Badge bg={status.bg}>{status.label}</Badge>
                </td>
                <td>
                  <div className="d-flex gap-1 flex-wrap">
                    <Button
                      size="sm"
                      variant="outline-primary"
                      title="Editar"
                      onClick={() => onEdit?.(payment)}
                    >
                      <i className="bi bi-pencil" />
                    </Button>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      title="Excluir"
                      disabled={isDeleting}
                      onClick={() => onDelete?.(payment)}
                    >
                      <i className="bi bi-trash" />
                    </Button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}
